import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useRouterChangeStart } from '../Utils/customHooks';
import { getDeviceType } from '../Utils/helper';
import { reviewFetcher } from '../datafetchers/productPage';
const CarouselPopup = dynamic(
  () => import('../components/Product/CarouselPopup'),
);
const DesktopCarousel = dynamic(
  () => import('../components/Product/DesktopCarouselPopup/DesktopCarousel'),
  {
    ssr: false,
  },
);
export default function AnyWhereUserReviewPopup(props) {
  const {
    imagesByUser,
    selectedIndex,
    showCarouselPopup,
    setShowCarouselPopup,
    productId,
  } = props;
  const [userImages, setUserImages] = useState([]);
  // const [showDesktopCarouselPopup, setShowDesktopCarouselPopup] =
  //     useState(false);
  const device = getDeviceType();

  const handleCarouselPopup = (url, shallow) => {
    if (device == 'mWeb') {
      {
        if (url.includes('productImageGallery')) {
          setShowCarouselPopup(true);
        } else {
          setShowCarouselPopup(false);
        }
      }
    }
  };
  useRouterChangeStart(handleCarouselPopup); // Performs an action when route change starts

  const fetchReviews = async () => {
    if (showCarouselPopup && !userImages?.length) {
      let reviewData = await reviewFetcher(productId, true);
      let user_review_images = reviewData?.data?.user_review_images;
      setUserImages(user_review_images);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [showCarouselPopup]);
  return (
    <>
      {showCarouselPopup && userImages?.length > 0 ? (
        <>
          {props.children}
          {device == 'mWeb' ? (
            <CarouselPopup
              productImages={userImages}
              location={'images_by_User'}
              selectedImageIndex={selectedIndex}
            />
          ) : (
            <>
              <DesktopCarousel
                productImages={userImages}
                location={'images_by_User'}
                selectedImageIndex={selectedIndex}
                showCarouselPopup={showCarouselPopup}
                setShowDesktopCarouselPopup={setShowCarouselPopup}
              />
            </>
          )}
        </>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
}
